import { ContentDiv, FooterDiv, HorizontalLineDiv } from "./style.js";

function Footer() {
  return (
    <FooterDiv>
      <HorizontalLineDiv />
      <ContentDiv>(C) SHIKHA VIRENDER CHANDEL - ALL RIGHTS RESERVED</ContentDiv>
    </FooterDiv>
  );
}

export default Footer;
